import axiosInstance from '@/libs/axios'
import pagination from '@/mixins/pagination'
import { localListAddItem, localListDeleteItem, localListUpdateItem } from '@/store/utils'

const getInitialState = () => ({
  fiscalTaxParameter: {
    ncm: '',
    stCbsIbsCode: null,
    fiscalClassificationCbsIbsCode: null,
    ratesVisible: false,
    cbsValue: null,
    cbsPercent: 0.0,
    cbsReductionPercent: 0.0,
    cbsDeferralPercent: 0.0,
    cbsEffectivePercent: 0.0,
    ibsStatePercent: 0.0,
    ibsStateReductionPercent: 0.0,
    ibsStateDeferralPercent: 0.0,
    ibsStateEffectivePercent: 0.0,
    ibsStateValue: null,
    ibsMunicipalPercent: 0.0,
    ibsMunicipalReductionPercent: 0.0,
    ibsMunicipalEffectivePercent: 0.0,
    ibsMunicipalDeferralPercent: 0.0,
    ibsMunicipalValue: null,
    stSelectiveTaxCode: null,
    fiscalClassificationSelectiveTaxCode: null,
    selectiveTaxType: 'PERCENTAGE_BY_BASE_VALUE',
    selectiveTaxPercent: 0.0,
    selectiveTaxValuePerUnit: 0.0,
    specificDestinationRules: [],
    active: true,
  },
  paging: pagination.data().paging,
})

export default {
  namespaced: true,
  state: getInitialState(),

  getters: {},

  mutations: {
    SET_FISCAL_TAX_PARAMETER(state, fiscalTaxParameter) {
      const current = state.fiscalTaxParameter || {}
      const merged = { ...current, ...fiscalTaxParameter }
      state.fiscalTaxParameter = merged
    },

    ADD_DESTINATION_RULE(state, rule) {
      state.fiscalTaxParameter.specificDestinationRules = localListAddItem(state.fiscalTaxParameter.specificDestinationRules, rule)
    },

    UPDATE_DESTINATION_RULE(state, { rule }) {
      state.fiscalTaxParameter.specificDestinationRules = localListUpdateItem(state.fiscalTaxParameter.specificDestinationRules, rule)
    },

    REMOVE_DESTINATION_RULE(state, idOrLocalId) {
      state.fiscalTaxParameter.specificDestinationRules = localListDeleteItem(state.fiscalTaxParameter.specificDestinationRules, idOrLocalId, true)
    },

    CLEAN_STATE(state) {
      const { fiscalTaxParameter, paging } = getInitialState()
      state.fiscalTaxParameter = fiscalTaxParameter
      state.paging = paging
    },
  },

  actions: {
    setFiscalTaxParameter({ commit }, fiscalTaxParameter) {
      commit('SET_FISCAL_TAX_PARAMETER', fiscalTaxParameter)
    },

    async loadFiscalTaxParameter({ commit }, { ncm, stateIdIbge, cityIdIbge }) {
      const { data } = await axiosInstance.get(`/api/tax/fiscal-tax-parameter`, {
        params: { ncm, stateIdIbge, cityIdIbge, },
      })

      commit('SET_FISCAL_TAX_PARAMETER', {
        ...data,
        ratesVisible: (
          data.stCbsIbsCode !== null ||
          data.fiscalClassificationCbsIbsCode !== null
        ) && data?.stCbsIbs?.requiresTaxation,
      })
    },

    addDestinationRule({ commit }, rule) {
      commit('ADD_DESTINATION_RULE', rule)
    },

    updateDestinationRule({ commit }, { index, rule }) {
      commit('UPDATE_DESTINATION_RULE', { index, rule })
    },

    removeDestinationRule({ commit }, item) {
      commit('REMOVE_DESTINATION_RULE', item.locaId || item.id)
    },

    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
  },
}
